
const state = {
  kakaRestApiAppKey: 'b1a0fe0e6a45cb014d6fa16aca21e7b3',
  kakaJavascriptApiAppKey: 'b1a0fe0e6a45cb014d6fa16aca21e7b3',
  subwayRadius: 1000, // 지하철 반경 미터단위
  mapStartPoint: { lat: 37.4803073, lng: 126.9328443 },
  mapStartLevel: 5,
  company: {
    name: '',
    owner: '',
    addr: '',
    bn: '', // 사업자번호
    ibn: '', // 통신판매업번호
    email: '',
    customerNumber: '',
    customerTime: ''
  },
  site: {
    domain: '',
    name: ''
  },
  popup: {
    show: false,
    url: '',
    code: ''
  }
}

const getters = {
}

const mutations = {
  setConfig: function (state, data) {
    // console.log('1:', data)
    state.company.name = data.company.name
    state.company.owner = data.company.owner
    state.company.addr = data.company.addr
    state.company.bn = data.company.bn
    state.company.ibn = data.company.ibn
    state.company.email = data.company.email
    state.company.customerNumber = data.company.customerNumber
    state.company.customerTime = data.company.customerTime
    // 사이트 정보
    state.site.domain = data.site.domain
    state.site.name = data.site.name
    // 팝업배너
    if (data.popup.code) {
      const date = new Date()
      const day = date.getDate()
      const popupBanner = localStorage.getItem('popupBanner')
      const savecode = data.popup.code + '-' + day
      if (popupBanner !== savecode) {
        state.popup.show = true
        state.popup.url = data.popup.url
        state.popup.code = data.popup.code
      }
    }
  }
}

const actions = {
  loadConfigData ({ commit, state }) {
    this.requestData(`/rep.config.api`, {}, {}).then(result => {
      commit('setConfig', result.array)
    }).catch((err) => {
      console.log(err)
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/config.js